<template>
  <section class="transfer-application" v-if="application">
    <can I="create" a="OpportunityApplication">
      <slot name="activator">
        <v-btn small flat fab @click="showForm = !showForm">
          <v-icon>mdi-transfer-right</v-icon>
        </v-btn>
      </slot>

      <v-dialog v-model="showForm" max-width="600">
        <v-card ref="dialog">
          <v-card-title class="title">Transfer Application</v-card-title>
          <v-card-text>
            <OpportunitySelect
              clearable
              :value="selected"
              @input="onSelect"
              @click:clear="onClear"
              :filter="{ organization: application.opportunity.organization }"
            />

            <p v-if="selected && selected > 0" class="confirmation-prompt">
              Confirm to create a new application for {{ opportunity.name }}.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat color="grey" @click="showForm = false" ref="cancel">Cancel</v-btn>
            <v-btn color="primary" @click="transfer" :disabled="!selected" ref="confirm"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </can>
  </section>
</template>

<script>
import OpportunitySelect from '@/components/selects/OpportunitySelect'

export default {
  components: { OpportunitySelect },

  props: { application: Object },

  data() {
    return { showForm: false, selected: null }
  },

  computed: {
    opportunity() {
      if (this.selected && this.selected > 0) {
        const opp = this.$store.getters['admin/opportunities/find'](this.selected)
        return opp || {}
      }
      return {}
    },
  },

  methods: {
    onSelect(id) {
      // Only accept valid selections (positive numeric IDs); ignore transient nulls from async refreshes
      if (id && Number(id) > 0) this.selected = Number(id)
    },
    onClear() {
      this.selected = null
    },
    transfer() {
      if (this.opportunity && this.opportunity.id && this.application && this.application.id) {
        this.$http
          .post(`admin/opportunities/${this.opportunity.id}/applications`, {
            applicationIds: [this.application.id],
          })
          .then(
            () => {
              this.$store.dispatch('snackbarSuccess', 'Application Created')
              this.showForm = false
            },
            () => {
              this.$store.dispatch('snackbarError', 'Application Failed')
            }
          )
      }
    },
  },
}
</script>
